import {Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@material-ui/core';
import React from 'react';
import {reverse} from 'core/urls';

/**
 * @template T
 * @typedef {Object} Column
 * @property {string} key
 * @property {string} label
 * @property {((value:any) => string)} format
 * @property {((row: T) => string)} render
 */
/**
 * @template T
 * @typedef {Object} Props
 * @property {T[]} data
 * @property {Column<T>[]} columns
 */
/**
 * @function
 * @template T
 * @param {Props<T>} props
 */
export default function Table(props) {
    const {columns, data, openOrderDetailOnRowClick} = props;

    function handleClick(id) {
        window.open(reverse('orderDetail', {id}), '_blank');
    }

    if (!data) return null;
    return (
        <TableContainer>
            <MuiTable>
                <TableHead>
                    <TableRow>
                        {columns.map(c => (
                            <TableCell key={`${c.key}.${c.label}`}>
                                {c.label}
                            </TableCell>
                        ))}

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, i) => (
                        <TableRow key={i} onClick={openOrderDetailOnRowClick ? () => handleClick(row.id) : null} hover={openOrderDetailOnRowClick} style={openOrderDetailOnRowClick && {cursor: 'pointer'}}>
                            {columns.map(c => {
                                const value = getValue(row, c.key);
                                return (
                                    <TableCell key={c.key}>
                                        {c.render && c.render(row)
                                            || c.format && c.format(value)
                                            || value}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </MuiTable>
        </TableContainer>
    );
}

const getValue = (row, key) => {
    let value = row;
    const keyPath = key.split('.');
    while (value && keyPath.length) {
        value = value[keyPath.shift()];
    }
    return value;
};



// WEBPACK FOOTER //
// ./components/tables/table.js